module.exports = __webpack_public_path__ + "static/media/ADA-BNB.191dfea9.svg";